import React from "react";
import {
  useAuth,
} from "../utils/AuthContext";
import RouteLoadingFallback from "./RouteLoadingFallback";

const AuthRouteGate = ({
  children,
  waitForProfile = true,
}) => {
  const {
    loading,
    profileLoading,
  } = useAuth();

  const pending =
    loading ||
    (waitForProfile &&
      profileLoading);

  if (pending) {
    return <RouteLoadingFallback />;
  }

  return children;
};

export default AuthRouteGate;
